import React from "react";
import { FaCoffee, FaEnvelope } from "react-icons/fa";
import "../styles/Footer.css";

const Footer = () => {
  const DONATION_URL =
    "https://www.paypal.com/donate/?business=L5829VKPFQWGW&no_recurring=0&item_name=Hey%2C+big+thanks+for+your+awesome+support%21+Glad+you+liked+the+Himalblock+Cheatsheets%E2%80%94means+a+lot.+You+rock%21%0A%0A%0A%0A&currency_code=USD";

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          © {new Date().getFullYear()} himalblock.com. All rights reserved.
        </div>
        <button
          onClick={() => (window.location.href = DONATION_URL)}
          className="coffee-link"
        >
          <FaCoffee />
          If you'd be so kind, a coffee or a small contribution would help keep
          my coding efforts brewing!
        </button>
        <a href="mailto:himalblock@gmail.com" className="email-link">
          <FaEnvelope />
          himalblock@gmail.com
        </a>
      </div>
    </footer>
  );
};

export default Footer;
